import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    IconButton,
} from '@material-ui/core'
import { makeStyles, Theme, useTheme } from '@material-ui/core/styles'
import { Close as CloseIcon } from '@material-ui/icons'
import { useDocumentViewerStyles } from './styles'

interface DocumentViewerProps {
    open: boolean
    documentId: number | null
    documentName?: string
    documentUrl?: string
    onClose: () => void
}

export const DocumentViewer: React.FC<DocumentViewerProps> = ({
    open,
    documentId,
    documentName,
    documentUrl,
    onClose,
}) => {
    const classes = useDocumentViewerStyles()
    const theme = useTheme()

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            classes={{ paper: classes.dialogPaper }}
        >
            <DialogTitle className={classes.dialogTitle}>
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                {documentUrl ? (
                    <div
                        style={{
                            flex: 1,
                            minHeight: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%',
                        }}
                    >
                        <iframe
                            src={documentUrl}
                            style={{
                                width: '100%',
                                flex: 1,
                                border: 'none',
                                backgroundColor: theme.palette.background.paper,
                            }}
                            title={documentName || 'Document'}
                        />
                    </div>
                ) : (
                    <Box className={classes.placeholder}>
                        <Typography variant="body2" color="textSecondary">
                            No document URL available
                        </Typography>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    )
}
